export function binarySearch<T>(arr: T[], propValue: T): number;
export function binarySearch<T, P extends keyof T>(arr: T[], propValue: T[P], prop: P): number;
export function binarySearch<T, P extends keyof T> (arr: T[], propValue: T[P] | T, prop: P | null = null) {
  let low = 0
  let high = arr?.length - 1

  while (low <= high) {
    const mid = low + high >>> 1
    const midVal = prop ? arr[mid]?.[prop] : arr[mid]
    if (midVal !== undefined && midVal !== null && midVal < propValue) {
      low = mid + 1
    } else {
      if (midVal !== undefined && midVal !== null && midVal <= propValue) {
        return mid
      }

      high = mid - 1
    }
  }

  return -(low + 1)
}
